import * as t from 'io-ts';

import {makeEnumRuntimeType, RBannerStateUidRef} from '../../../models/api/apiTypes';
import {InviteTeammatePopoverAccessPointsEnum} from '../../../services/tracking';
import {makeTransientResourceMap} from '../../appTypes';
import {PanelTypesEnum, RAppPanelId, RPanelStateBase} from '../panelStateBase';
import {RNavigationBlockerId} from './appPanelHelpers';
import {RBannerState} from './banners/bannersState';
import {RAppContentType, RAppParameters} from './parameters/appParameters';

/*
 * Runtime types.
 */

const RInviteTeammatePopoverState = t.type({
  accessPoint: makeEnumRuntimeType(InviteTeammatePopoverAccessPointsEnum),
});

export const RAppPanelState = t.intersection([
  RPanelStateBase,
  t.type({
    id: RAppPanelId,
    type: t.literal(PanelTypesEnum.APP),
    contentType: RAppContentType,
    defaultContentType: RAppContentType,
    navigationBlockerIds: t.readonlyArray(RNavigationBlockerId),
    banners: makeTransientResourceMap(t.string, RBannerState),
    visibleBannerUids: t.readonlyArray(RBannerStateUidRef),
    undoBannerUids: t.readonlyArray(RBannerStateUidRef),
    errorBannerUids: t.readonlyArray(RBannerStateUidRef),
    helpChatOpenAttempt: t.Integer,
    isDemoInboxLoadingModalOpen: t.boolean,
    inviteTeammatePopover: t.union([RInviteTeammatePopoverState, t.undefined]),
  }),
  t.partial({
    blockedNavigation: t.type({
      parameters: RAppParameters,
    }),
  }),
]);

/*
 * Types.
 */

export interface InviteTeammatePopoverState extends Readonly<t.TypeOf<typeof RInviteTeammatePopoverState>> {}
export interface AppPanelState extends Readonly<t.TypeOf<typeof RAppPanelState>> {}
